import { Component, Input, OnInit, ViewChild } from "@angular/core";

import {
    ChartComponent,
    ApexAxisChartSeries,
    ApexChart,
    ApexPlotOptions,
    ApexXAxis,
    ApexFill,
    ApexLegend
} from "ng-apexcharts";

export type ChartOptions = {
    series: ApexAxisChartSeries;
    chart: ApexChart;
    fill: ApexFill;
    legend: ApexLegend;
    xaxis: ApexXAxis;
    plotOptions: ApexPlotOptions;
};

@Component({
    selector: 'lib-advanced-timeline-chart',
    templateUrl: './advanced-timeline-chart.component.html'
})
export class AdvancedTimelineChartComponent implements OnInit {

    @ViewChild("chart") chart: ChartComponent;
    public chartOptions: Partial<ChartOptions>;

    ngOnInit() {
        this.chartOptions = {
            series: [
                {
                    name: "Nadorcott",
                    data: [
                        {
                            x: "Sudáfrica",
                            y: [
                                new Date("2019-03-05").getTime(),
                                new Date("2019-03-08").getTime()
                            ]
                        },
                        {
                            x: "Marruecos",
                            y: [
                                new Date("2019-03-02").getTime(),
                                new Date("2019-03-05").getTime()
                            ]
                        },
                        {
                            x: "Chile",
                            y: [
                                new Date("2019-03-05").getTime(),
                                new Date("2019-03-07").getTime()
                            ]
                        },
                        {
                            x: "Perú",
                            y: [
                                new Date("2019-03-03").getTime(),
                                new Date("2019-03-09").getTime()
                            ]
                        },
                        {
                            x: "España",
                            y: [
                                new Date("2019-03-08").getTime(),
                                new Date("2019-03-11").getTime()
                            ]
                        }
                    ]
                },
                {
                    name: "Leanri",
                    data: [
                        {
                            x: "Sudáfrica",
                            y: [
                                new Date("2019-03-02").getTime(),
                                new Date("2019-03-05").getTime()
                            ]
                        },
                        {
                            x: "Marruecos",
                            y: [
                                new Date("2019-03-06").getTime(),
                                new Date("2019-03-16").getTime()
                            ]
                        },
                        {
                            x: "Chile",
                            y: [
                                new Date("2019-03-03").getTime(),
                                new Date("2019-03-07").getTime()
                            ]
                        },
                        {
                            x: "Perú",
                            y: [
                                new Date("2019-03-20").getTime(),
                                new Date("2019-03-22").getTime()
                            ]
                        },
                        {
                            x: "España",
                            y: [
                                new Date("2019-03-10").getTime(),
                                new Date("2019-03-16").getTime()
                            ]
                        }
                    ]
                },
                {
                    name: "ARCCIT9",
                    data: [
                        {
                            x: "Sudáfrica",
                            y: [
                                new Date("2019-03-10").getTime(),
                                new Date("2019-03-17").getTime()
                            ]
                        },
                        {
                            x: "Chile",
                            y: [
                                new Date("2019-03-05").getTime(),
                                new Date("2019-03-09").getTime()
                            ]
                        },
                        {
                            x: "España",
                            y: [
                                new Date("2019-03-05").getTime(),
                                new Date("2019-03-17").getTime()
                            ]
                        }
                    ]
                }
            ],
            chart: {
                width: 500,
                height: 450,
                type: "rangeBar"
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    barHeight: "50%"
                }
            },
            xaxis: {
                type: "datetime"
            },
            fill: {
                type: "gradient",
                gradient: {
                    shade: "light",
                    type: "vertical",
                    shadeIntensity: 0.25,
                    gradientToColors: undefined,
                    inverseColors: true,
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [50, 0, 100, 100]
                }
            },
            legend: {
                position: "top",
                horizontalAlign: "center"
            }
        };
    }
}

